export const PAGE_SIZE = 50;

export const PATIENT_TABS = [
  { id: "main", label: "Основное" },
  { id: "groups", label: "Группы" },
  { id: "memberships", label: "Абонементы" },
  { id: "attendance", label: "Посещаемость" },
  { id: "notes", label: "Заметки" },
  { id: "documents", label: "Документы" },
];

/** Старые ссылки ?tab=finance|sport|medicine */
export const PATIENT_TAB_ALIASES = {
  finance: "memberships",
  sport: "groups",
  medicine: "main",
};

export const EMPTY_CREATE = {
  email: "",
  password: "",
  fullName: "",
  phone: "",
  date_of_birth: "",
  gender: "",
  snils: "",
  group_id: "",
};

export const EMPTY_EDIT = {
  full_name: "",
  email: "",
  phone: "",
  date_of_birth: "",
  internal_notes: "",
  is_blocked: false,
  gender: "",
  address: "",
  snils: "",
  policy_oms: "",
  blood_type: "",
  allergies: "",
  chronic_conditions: "",
  medical_history: "",
  emergency_contact_name: "",
  emergency_contact_phone: "",
  consent_pd: false,
  consent_medical: false,
  medical_clearance_expires_at: "",
  medical_clearance_file_url: "",
  rank_belt: "",
  telegram_username: "",
  is_archived: false,
  lead_source: "",
  tags: [],
};

export const GENDER_OPTIONS = [
  { value: "", label: "—" },
  { value: "male", label: "Мужской" },
  { value: "female", label: "Женский" },
  { value: "other", label: "Другое" },
];

export function patientToEdit(p) {
  const card = p?.patient_card || {};
  return {
    full_name: p?.full_name || "",
    email: p?.email || "",
    phone: p?.phone || "",
    date_of_birth: p?.date_of_birth || "",
    internal_notes: p?.internal_notes || "",
    is_blocked: !!p?.is_blocked,
    gender: card.gender || "",
    address: card.address || "",
    snils: card.snils || "",
    policy_oms: card.policy_oms || "",
    blood_type: card.blood_type || "",
    allergies: card.allergies || "",
    chronic_conditions: card.chronic_conditions || "",
    medical_history: card.medical_history || "",
    emergency_contact_name: card.emergency_contact_name || "",
    emergency_contact_phone: card.emergency_contact_phone || "",
    consent_pd: !!card.consent_pd,
    consent_medical: !!card.consent_medical,
    medical_clearance_expires_at: card.medical_clearance_expires_at || "",
    medical_clearance_file_url: card.medical_clearance_file_url || "",
    rank_belt: card.rank_belt || "",
    telegram_username: card.telegram_username || "",
    is_archived: !!card.is_archived,
    lead_source: card.lead_source || "",
    tags: Array.isArray(card.tags) ? [...card.tags] : [],
  };
}

export const PATIENTS_BASE = "/manage/app/clients";

/** Реальный email для входа клиента (не служебный @patient.internal). */
export function isPortalLoginEmail(email) {
  const v = String(email || "").trim().toLowerCase();
  return !!v && !v.includes("@patient.internal");
}

/** Якоря одностраничной карточки клиента */
export const CLIENT_PROFILE_ANCHORS = [
  { id: "wall", label: "Стена" },
  { id: "achievements", label: "Достижения" },
  { id: "client-overview", label: "Обзор" },
  { id: "client-memberships", label: "Оплата" },
  { id: "client-attendance", label: "Журнал" },
  { id: "client-events", label: "События" },
  { id: "client-notes", label: "Заметки" },
];

export const CLIENT_PROFILE_TAB_TO_ANCHOR = {
  main: "client-overview",
  groups: "client-overview",
  sport: "client-overview",
  memberships: "client-memberships",
  finance: "client-memberships",
  attendance: "client-attendance",
  notes: "client-notes",
  documents: "client-overview",
  events: "client-events",
  medicine: "client-overview",
  info: "client-overview",
  "client-info": "client-overview",
  "client-sport": "client-overview",
};
